"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _index = _interopRequireDefault(require("./index.scss"));

var _classnames = _interopRequireDefault(require("classnames"));

// Paragraph
// =========
var Paragraph = function Paragraph(_ref) {
  var type = _ref.type,
      children = _ref.children,
      className = _ref.className,
      inlineStyles = _ref.inlineStyles,
      dataTestId = _ref.dataTestId;
  return _react["default"].createElement("p", {
    className: (0, _classnames["default"])(_index["default"][type], className),
    style: inlineStyles,
    "data-test-id": dataTestId
  }, children);
};

Paragraph.defaultProps = {
  type: 'medium'
};
Paragraph.propTypes = {
  type: _propTypes["default"].oneOf(['large', 'medium', 'small']),
  className: _propTypes["default"].string,
  inlineStyles: _propTypes["default"].object,
  dataTestId: _propTypes["default"].string,
  children: _propTypes["default"].node
};
var _default = Paragraph;
exports["default"] = _default;